import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import actionTypes from 'constants/actionTypes';

import { usePublishIncentiveOfferModal } from '../context/PublishIncentiveOfferModalContext';

import PublishIncentiveOfferModalStep1 from './PublishIncentiveOfferModalStep1';
import PublishIncentiveOfferModalStep2 from './PublishIncentiveOfferModalStep2';

const getStepLiClassName = (stepNumber: number, currentStep: number) => {
  if (stepNumber === currentStep) return 'current';
  if (stepNumber < currentStep) return 'done';
  return '';
};

const PublishIncentiveOfferModalBody: FC = () => {
  const { t } = useTranslate();
  const { data } = usePublishIncentiveOfferModal();

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  if (isReadOnlyView) {
    return (
      <Modal.Body className="py-4">
        <PublishIncentiveOfferModalStep1 />
      </Modal.Body>
    );
  }

  return (
    <Modal.Body className="py-4">
      <ul className="nk-stepper-nav nav nav-tabs nav-tabs-s2 accept-trading-offer-stepper mb-4 list-unstyled d-flex w-100">
        <li
          className={`${getStepLiClassName(1, data.currentStep)} flex-grow-1`}
          data-step="1"
        >
          <span className="step-item">
            <span className="step-text">{t('Summary')}</span>
          </span>
        </li>
        <li
          className={`${getStepLiClassName(2, data.currentStep)} flex-grow-1`}
          data-step="2"
        >
          <span className="step-item">
            <span className="step-text">{t('Verification')}</span>
          </span>
        </li>
      </ul>

      <div className="nk-stepper-content">
        <div className="nk-stepper-steps stepper-steps">
          {data.currentStep === 1 && <PublishIncentiveOfferModalStep1 />}
          {data.currentStep === 2 && <PublishIncentiveOfferModalStep2 />}
        </div>
      </div>
    </Modal.Body>
  );
};

export default PublishIncentiveOfferModalBody;
